import { FC, ReactNode } from 'react';
import { icons, Icons } from '../../icons/IconSet';
import Input, { IInput, TInputEvent } from './Input';
import Truncate from '../Truncate';

const InputIconEraser: FC<IInput & {
  icon?: Icons,
  description?: ReactNode,
  isUrl?: boolean,
  noEraser?: boolean,
}> = ({
  icon,
  label,
  description,
  isUrl,
  noEraser = false,
  ...inputProps
}) => {
  const size = inputProps?.size || 'medium';

  return (
    <div className="flex flex-col gap-[.2em]">
      {!!label && <div className="pl-1">{label}</div>}
      
      <div className="flex items-center h-[2.5em] border-border_color border-[1px] rounded-lg">
        <div 
          {...(isUrl && inputProps?.value
            ? {
              role: "button",
              tabIndex: -1,
              onClick: () => inputProps?.value && window.open(String(inputProps.value), "_blank", "noreferrer"),
            }
            : {}
          )}
          className={`
            flex items-center justify-center border-r-[1px] h-[100%] bg-gray-50 rounded-l-lg border-border_color p-1
            ${inputProps?.value ? '' : '[&_*]:opacity-70'}
            ${isUrl && inputProps?.value ? 'cursor-pointer' : ''}
          `}
        >
          {icons(
            icon
            || (isUrl && 'square-arrow-out-up-right')
            || 'message-square-text',
            { height: '16px' }
          )}
        </div>
        <div className="flex flex-1 flex-col">                
          <Input
            noBorder
            classNameField="pl-0"
            {...inputProps}
          />
        </div>
        {!noEraser && (
          <div
            tabIndex={-1}
            role="button"
            onClick={() => inputProps?.handle && inputProps.handle({ target: { value: '' }} as TInputEvent)}
            className={`
              border-l-[1px] h-[100%] border-border_color p-1 flex items-center justify-center 
              ${inputProps?.value ? '[&_*]:opacity-50 [&:hover_*]:opacity-100 [&:hover_*]:transition-all' : '[&_*]:opacity-50'}
            `}
          >
            {icons('eraser', { height: '16px' })}
          </div>
        )}          
      </div>
      {!!description && (
        <div className="text-sm pl-1 opacity-60">
          <Truncate>
            {description}
          </Truncate>
        </div>
      )}      
    </div>
  );
}

export default InputIconEraser;
